


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Empty extends Vue {
  @Prop({
    type: Boolean,
    required: true
  })
  readonly condition!: boolean;

  @Prop({
    type: String,
    required: true
  })
  readonly text!: string;

  @Prop({
    type: String,
    required: true
  })
  readonly actionText!: string;

  @Prop({
    type: String,
    required: true
  })
  readonly to!: string;
}
